import { HlDisplayCreditBlockedService } from './../../services/hl-display-credit-blocked.service';
import { Component, inject, OnInit } from '@angular/core';
import {
  CustomerListCardComponent,
  SelectedCustomerService,
  Customer,
  GungModalService,
  AuthService
} from 'gung-standard';
import { environment } from '../../../environments/environment';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { HlDisplayCustomerMeetingModalComponent } from '../hl-display-customer-meeting-modal/hl-display-customer-meeting-modal.component';
import { Router } from '@angular/router';
import { first, from, Observable, of, skipWhile, switchMap } from 'rxjs';
import { HlDisplayNavbarConfigService } from '../../services/hl-display-navbar-config.service';

@Component({
  selector: 'app-hl-customer-list-card',
  templateUrl: './hl-customer-list-card.component.html',
  styleUrls: ['./hl-customer-list-card.component.scss'],
  standalone: false
})
export class HlCustomerListCardComponent extends CustomerListCardComponent {
  protected navbarConfigService = inject(HlDisplayNavbarConfigService);

  isSales: boolean = false;
  isManager: boolean = false;

  constructor(
    selectedCustomerService: SelectedCustomerService,
    protected router: Router,
    protected modalService: NgbModal,
    protected gungModalService: GungModalService,
    protected creditBlockedService: HlDisplayCreditBlockedService,
    protected authService: AuthService
  ) {
    super(selectedCustomerService, router);
    this.authService
      .getRoles()
      .pipe(first())
      .subscribe(roles => {
        this.isSales = roles.includes('SALES');
        this.isManager = roles.includes('MANAGER');
      });
  }

  selectCustomer(customer: Customer): Observable<void> {
    return this.creditBlockedService.checkCreditBlocked(customer).pipe(
      first(),
      switchMap(result => {
        if (result.status === 'CREDIT_HARD_BLOCK') {
          const options: NgbModalOptions = {
            backdrop: 'static',
            size: 'sm',
            keyboard: true
          };
          const translation = this.creditBlockedService.getPortalTranslationCustomer(customer);
          return from(
            this.gungModalService.openBasicModal(translation.title, translation.body, options).then(
              () => {},
              () => {}
            )
          ).pipe(switchMap(() => of(null)));
        } else {
          this.selectCustomerService.selectCustomer(customer.id);
          return this.selectCustomerService.getSelectedCustomer().pipe(
            skipWhile(newCustomer => !newCustomer || customer.id !== newCustomer.id), // Skip until the desired customer is selected
            first(), // Complete after the first emission
            switchMap(() => of(null)) // Return an observable that completes
          );
        }
      })
    );
  }

  onOrderClick(customer: Customer) {
    this.selectCustomer(customer).subscribe(() => {
      this.navbarConfigService
        .getProductListNavigationQueryParams()
        .pipe(first())
        .subscribe(productListQueryParams => {
          this.router.navigate(['/products'], { queryParams: productListQueryParams });
        });
    });
  }

  onCustomerClick(customer: Customer) {
    this.selectCustomer(customer).subscribe(() => {
      this.router.navigate(['/customers/' + customer.id]);
    });
  }

  openMeeting(customer: Customer) {
    const modalReference = this.modalService.open(HlDisplayCustomerMeetingModalComponent, {
      backdrop: true || 'static',
      size: 'lg',
      keyboard: true
    });

    modalReference.componentInstance.customer = customer;

    modalReference.result.then(
      result => {
        console.log('result: ', result);
      },
      error => {
        console.log('error: ', error);
      }
    );
  }
}
